module.exports = __webpack_public_path__ + "static/zama-4-df7743ec8c5c07586e52531ddf5bc148.gif";